import { Tabs as TabsPrimitive, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const Tabs = React.forwardRef(({ className, children, ...props }, ref) => {
    return (React.createElement(TabsPrimitive, { ref: ref, className: cn("in-tabs", className), ...props }, children));
});
Tabs.displayName = "Tabs";
export { Tabs };
//# sourceMappingURL=tabs.js.map